import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

const Overview = () => {
  const [headRef, headVisible] = useScrollReveal();
  const [textRef, textVisible] = useScrollReveal({ threshold: 0.2 });
  const [statsRef, statsVisible] = useScrollReveal({ threshold: 0.3 });

  return (
    <section id="overview" className="py-24 lg:py-32 bg-white relative overflow-hidden border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Editorial split header */}
        <div ref={headRef} className={`grid lg:grid-cols-2 gap-10 lg:gap-20 mb-20 transition-all duration-700 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div>
            <span className="inline-block text-[11px] tracking-[0.3em] uppercase font-semibold text-accent-500 mb-5">
              Understanding The Opportunity
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-dark-800 leading-tight">
              What Is{' '}
              <span className="italic text-primary-600">Mumbai 3.0?</span>
            </h2>
          </div>
          <div className="flex items-end">
            <div ref={textRef} className={`transition-all duration-700 delay-200 ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <p className="text-dark-500 leading-[1.9] text-[15px] font-light">
                This city is being built right next to Navi Mumbai, developing in 2 parts —
                <strong> NAINA</strong> (Developing Authority: CIDCO) and
                <strong> KSC (Karnala-Sai-Chirner)</strong> (Developing Authority: MMRDA).
              </p>
            </div>
          </div>
        </div>

        {/* Content + Bento stats */}
        <div className="grid lg:grid-cols-5 gap-6">
          {/* Left text block */}
          <div className={`lg:col-span-2 transition-all duration-700 delay-300 ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="text-dark-400 leading-[2] text-[15px] font-light mb-6">
              Mumbai is expanding, and the next massive wave of infrastructural and economic growth
              is happening right now. Mumbai 3.0 represents a golden opportunity for strategic land
              investment, offering high appreciation potential, exceptional connectivity, and master-planned urban development.
            </p>
            <p className="text-dark-400 leading-[2] text-[15px] font-light italic border-l-2 border-accent-400/50 pl-5">
              Discover an investment opportunity at the nexus of Mumbai's $30 Billion Infrastructure Boom.
            </p>
            <button onClick={() => window.dispatchEvent(new Event('openContactModal'))} className="inline-flex items-center gap-2.5 mt-8 bg-primary-600 text-white rounded-full px-7 py-3 text-[11px] font-semibold tracking-wider uppercase hover:bg-primary-700 hover:shadow-lg transition-all duration-500 group">
              Enquire Now
              <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>

          {/* Right: Info cards */}
          <div ref={statsRef} className={`lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4 transition-all duration-700 ${statsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="bg-primary-50/70 border border-primary-100/50 rounded-2xl p-6 lg:p-8">
              <h3 className="font-heading text-xl text-primary-600 mb-3">NAINA Region</h3>
              <p className="text-dark-400 text-sm leading-relaxed font-light">
                Navi Mumbai Airport Influence Notified Area — developed by CIDCO, spanning 371 sq km with planned townships, commercial hubs, and world-class infrastructure.
              </p>
            </div>
            <div className="bg-accent-50/50 border border-accent-100/50 rounded-2xl p-6 lg:p-8">
              <h3 className="font-heading text-xl text-accent-600 mb-3">KSC New Town</h3>
              <p className="text-dark-400 text-sm leading-relaxed font-light">
                Karnala-Sai-Chirner corridor under MMRDA — a strategic growth zone benefiting from MTHL connectivity and proximity to Navi Mumbai International Airport.
              </p>
            </div>
            <div className="sm:col-span-2 bg-gray-50 border border-gray-100 rounded-2xl p-6 lg:p-8">
              <h3 className="font-heading text-xl text-dark-700 mb-3">Why Invest Now?</h3>
              <p className="text-dark-400 text-sm leading-relaxed font-light">
                With the Navi Mumbai International Airport nearing completion and the Mumbai Trans-Harbour Link (MTHL) already operational, land values in these regions are poised for significant appreciation. Early investors stand to benefit from pre-development pricing and government-backed infrastructure growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overview;
